<h4>{{ titleCard }}</h4>

<mat-dialog-content class="mat-typography">
  <mat-stepper
    class="example-stepper"
    [orientation]="(stepperOrientation | async)!"
  >
    <mat-step [stepControl]="usersForm" label="Datos generales">
      <form [formGroup]="usersForm" autocomplete="off">
        <div fxLayout="row wrap" fxLayoutAlign="space-between center">
          <!-- column Nombre -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                matInput
                type="text"
                formControlName="Nombre"
                placeholder="Nombre"
                [errorStateMatcher]="matcher"
                (change)="setUsername()"
                required
              />
              <mat-icon
                matSuffix
                *ngIf="
                  usersForm.get('Nombre')?.errors &&
                  usersForm.get('Nombre')?.touched
                "
                style="color: #da5757"
                >report</mat-icon
              >
              <mat-error *ngIf="usersForm.get('Nombre')?.hasError('required')">
                El nombre es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column ApellidoPaterno -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Apellido paterno</mat-label>
              <input
                matInput
                type="text"
                formControlName="ApellidoPaterno"
                placeholder="Apellido Paterno"
                [errorStateMatcher]="matcher"
                (change)="setUsername()"
                required
              />
              <mat-icon
                matSuffix
                *ngIf="
                  usersForm.get('ApellidoPaterno')?.errors &&
                  usersForm.get('ApellidoPaterno')?.touched
                "
                style="color: #da5757"
                >report</mat-icon
              >
              <mat-error
                *ngIf="usersForm.get('ApellidoPaterno')?.hasError('required')"
              >
                El apellido paterno es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column ApellidoMaterno -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Apellido materno</mat-label>
              <input
                matInput
                type="text"
                formControlName="ApellidoMaterno"
                placeholder="Apellido Materno"
                [errorStateMatcher]="matcher"
                required
              />
              <mat-icon
                matSuffix
                *ngIf="
                  usersForm.get('ApellidoMaterno')?.errors &&
                  usersForm.get('ApellidoMaterno')?.touched
                "
                style="color: #da5757"
                >report</mat-icon
              >
              <mat-error
                *ngIf="usersForm.get('ApellidoMaterno')?.hasError('required')"
              >
                El apellido materno es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column Nickname -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Nickname</mat-label>
              <input
                matInput
                type="text"
                formControlName="Nickname"
                placeholder="Nickname"
                [errorStateMatcher]="matcher"
                required
              />
              <mat-icon
                matSuffix
                *ngIf="
                  usersForm.get('Nickname')?.errors &&
                  usersForm.get('Nickname')?.touched
                "
                style="color: #da5757"
                >report</mat-icon
              >
              <mat-error
                *ngIf="usersForm.get('Nickname')?.hasError('required')"
              >
                El Nickname es obligatorio
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column telefono -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Télefono</mat-label>
              <input
                matInput
                type="text"
                formControlName="Telefono"
                placeholder="Telefono"
              />
            </mat-form-field>
          </div>

          <!-- column extension -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Extensión</mat-label>
              <input
                matInput
                type="text"
                formControlName="Extension"
                placeholder="Extension"
              />
            </mat-form-field>
          </div>

          <!-- column Email -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input
                matInput
                type="email"
                formControlName="Email"
                placeholder="Email"
                [errorStateMatcher]="matcher"
                required
              />
              <mat-icon
                matSuffix
                *ngIf="
                  usersForm.get('Email')?.errors &&
                  usersForm.get('Email')?.touched
                "
                style="color: #da5757"
                >report</mat-icon
              >
              <mat-error *ngIf="usersForm.get('Email')?.hasError('required')">
                El correo es obligatorio
              </mat-error>
              <mat-error
                *ngIf="
                  usersForm.get('Email')?.hasError('email') ||
                  usersForm.get('Email')?.hasError('pattern')
                "
              >
                Ingrese un correo válido.
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column Contrasena -->
          <div
            fxFlex.md="50"
            fxFlex.lg="50"
            fxFlex.sm="100"
            class="p-10"
            *ngIf="this.user.Id"
          >
            <mat-form-field appearance="outline">
              <mat-label>Contraseña actual</mat-label>
              <input
                matInput
                type="password"
                formControlName="ContrasenaActual"
                placeholder="Contraseña actual"
                [errorStateMatcher]="matcher"
                [type]="hide3 ? 'password' : 'text'"
                (keyup)="checkValue($event.target)"
                autocomplete="off"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hide3 = !hide3"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide3"
              >
                <mat-icon>{{
                  hide3 ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error *ngIf="passwordCurrent?.invalid">
                {{ getErrorMsjPasswordCurrent() }}</mat-error
              >
            </mat-form-field>
          </div>

          <!-- column Contrasena -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>{{ labelContrasena }}</mat-label>
              <input
                matInput
                type="password"
                formControlName="Contrasena"
                placeholder="{{ labelContrasena }}"
                [errorStateMatcher]="matcher"
                [type]="hide ? 'password' : 'text'"
                autocomplete="off"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="'Hide password'"
                [attr.aria-pressed]="hide"
              >
                <mat-icon>{{
                  hide ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error *ngIf="password?.invalid">
                {{ getErrorMsjPassword() }}</mat-error
              >
            </mat-form-field>
          </div>

          <!-- column confirmarContrasena -->
          <div
            fxFlex.md="50"
            fxFlex.lg="50"
            fxFlex.sm="100"
            class="p-10"
            *ngIf="
              usersForm.get('Contrasena')?.valid ||
              usersForm.get('Contrasena')?.value != ''
            "
          >
            <mat-form-field appearance="outline">
              <mat-label>{{ labelConfirmarContrasena }}</mat-label>
              <input
                matInput
                type="password"
                formControlName="confirmarContrasena"
                placeholder="{{ labelConfirmarContrasena }}"
                [type]="hide2 ? 'password' : 'text'"
                [errorStateMatcher]="matcher"
                autocomplete="off"
              />
              <button
                type="button"
                mat-icon-button
                matSuffix
                (click)="hide2 = !hide2"
                [attr.aria-label]="'Hide2 password'"
                [attr.aria-pressed]="hide2"
              >
                <mat-icon>{{
                  hide2 ? "visibility_off" : "visibility"
                }}</mat-icon>
              </button>
              <mat-error *ngIf="confirmarPassword?.invalid">
                {{ getErrorMsjConfirmarPassword() }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- column Dirección -->
          <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Dirección</mat-label>
              <input
                matInput
                type="text"
                formControlName="Direccion"
                placeholder="Dirección"
              />
            </mat-form-field>
          </div>

          <!-- column Tel Oficinas  -->
          <div fxFlex.md="100" fxFlex.lg="100" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Tel Oficinas</mat-label>
              <input
                matInput
                type="text"
                formControlName="TelOficinas"
                placeholder="Tel Oficinas"
              />
            </mat-form-field>
          </div>

          <!-- column RutaImagen -->
          <!-- <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
                        <mat-form-field appearance="outline" [ngStyle]="{'width': fileExists ? dynamicWidth : '100%'}">
                            <mat-label>Foto</mat-label>
                            <ngx-mat-file-input type="file" formControlName="Imagen" multiple="false"
                                [accept]="['.jpg', 'image/*']" color='#fff' (ngModelChange)="onFileSelected($event)">
                            </ngx-mat-file-input>
                        </mat-form-field>
                        <img *ngIf="fileExists" src="{{imageUrl}}" alt="" class="img-user">
                    </div> -->

          <!-- column IdPuestoTrabajo -->
          <!-- <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
                        <mat-form-field appearance="outline">
                            <mat-label>Puesto</mat-label>
                          <input   type="text"   placeholder="Puesto de trabajo"  matInput  formControlName="Puestos"
                            (keyup)="filterData($event.target.value, 1)"  
                            (change)="filterData($event.target.value, 1)"  
                            [matAutocomplete]="Puestos" 
                            required
                          >
                          <mat-autocomplete #Puestos>
                            <mat-option  *ngFor="let puesto of filteredPuestos"  [value]="puesto.Nombre"
                              (click)="setPuesto(puesto.Id)"
                              (onSelectionChange)="setPuesto(puesto.Id)">
                              {{ puesto.Nombre }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div> -->

          <!-- column Roles -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <mat-form-field appearance="outline">
              <mat-label>Roles</mat-label>
              <input
                type="text"
                placeholder="Roles"
                matInput
                formControlName="NombreRol"
                [matAutocomplete]="Roles"
                (keyup)="filterData($event.target.value, 2)"
                (change)="filterData($event.target.value, 2)"
              />
              <mat-autocomplete #Roles="matAutocomplete">
                <mat-option
                  *ngFor="let rol of filteredRoles"
                  [value]="rol.Nombre"
                  (click)="setIdRol(rol.Id)"
                >
                  {{ rol.Nombre }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>

          <!-- column EsCalibrador -->
          <div
            fxFlex.md="50"
            fxFlex.lg="50"
            fxFlex.sm="100"
            class="p-10"
            *ngIf="showCalibration"
          >
            <mat-checkbox
              formControlName="EsCalibrador"
              (change)="isCalibrator()"
              >¿Es un usuario de calibración?
            </mat-checkbox>
          </div>

          <!-- column FirmaDigital -->
          <div fxFlex.md="50" fxFlex.lg="50" fxFlex.sm="100" class="p-10">
            <app-firma-upload
              [allowedTypes]="['image/png', 'image/jpeg', 'image/jpg']"
              (fileSelected)="onFileSelectedFirma($event)"
              [existingImageUrl]="imageUrlFirma"
            >
            </app-firma-upload>
          </div>
        </div>

        <div
          fxLayout="row"
          fxLayoutAlign="space-around center"
          class="marginAccordion"
        >
          <button mat-stroked-button color="warn" (click)="close()">
            Cancelar
          </button>
          <button mat-stroked-button color="primary" matStepperNext>
            Siguiente
          </button>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="usersForm" label="Permisos módulos">
      <mat-label>Acceso a las funciones</mat-label>
      <br />
      <form [formGroup]="usersForm">
        <mat-accordion formArrayName="Modulos" class="marginAccordion">
          <mat-expansion-panel
            (opened)="panelOpenState = true"
            (closed)="panelOpenState = false"
            *ngFor="let item of permisosModulos.controls; let i = index"
            [formGroupName]="i"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-label>
                  <mat-checkbox formControlName="CheckedModulo">{{
                    item.get("Nombre").value
                  }}</mat-checkbox>
                </mat-label>
              </mat-panel-title>
              <mat-panel-description></mat-panel-description>
            </mat-expansion-panel-header>
            <div
              formArrayName="SubModulos"
              *ngIf="item.get('SubModulos').length"
            >
              <div
                *ngFor="
                  let hijo of item.get('SubModulos').controls;
                  let j = index
                "
                [formGroupName]="j"
              >
                <mat-checkbox
                  formControlName="CheckedSubModulo"
                  class="example-margin"
                >
                  {{ hijo.get("Nombre").value }}</mat-checkbox
                >
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div
          fxLayout="row"
          fxLayoutAlign="space-around center"
          class="marginAccordion"
        >
          <mat-progress-bar
            *ngIf="loading"
            color="primary"
            mode="indeterminate"
          ></mat-progress-bar>
          <button mat-stroked-button color="warn" (click)="close()">
            Cancelar
          </button>
          <button
            mat-stroked-button
            color="success"
            type="submit"
            (click)="saveUser()"
          >
            Guardar
          </button>
        </div>
      </form>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
